<template>
  <div>
    <slot name="group:title"></slot>
    <div class="grid col-span-2 gap-4 sm:grid-cols-2">
      <component
        v-for="c in components"
        :key="c.key"
        :is="c.name"
        :controls="controls"
        :value="c.value"
        :checked="c.value"
        :http-errors="c.errors"
        @input:field="onInput($event, c.key)"
      ></component>
    </div>
  </div>
</template>

<script>
import TermsOfUse from "@/components/Field/CheckList/TermsOfUse";
import ContactConsent from "@/components/Field/CheckList/ContactConsent";

const FIELDS = ["terms_of_use", "contact_consent"];
export default {
  components: {
    TermsOfUse,
    ContactConsent,
  },
  props: ["controls", "errors"],
  computed: {
    hasTermsOfUse() {
      return this.$store.getters.hasTermsOfUse;
    },
    hasContactConsent() {
      return this.$store.getters.location?.settings?.has_contact_consent;
    },
    fields() {
      if (!this.hasTermsOfUse) {
        FIELDS.filter((field) => field !== "terms_of_use");
      }
      if (!this.hasContactConsent) {
        FIELDS.filter((field) => field !== "contact_consent");
      }
      return FIELDS;
    },
    components() {
      return this.fields.map((el) => ({
        key: el,
        name: el.replace(/_/g, "-"),
        value: this.controls[el],
        errors: this.errors?.validation?.[`input.${el}`],
      }));
    },
  },
  methods: {
    onInput(value, key) {
      this.$emit("input:group", { value, key });
      if (value) {
        this.$telemetry.trackEvent({
          name: "patient_details." + key + "." + value,
        });
      }
    },
  },
};
</script>
